import { add, intervalToDuration } from 'date-fns'
import HistoryEntry from '../../../src/components/Questions/HistoryEntry/HistoryEntry'

const getHistoryDuration = (entries: Record<string, HistoryEntry>): Duration => {
  const durations: Duration[] = []

  Object.keys(entries).forEach((key) => {
    const entry = entries[key]
    const years = entry.lengthOfTime?.years ? parseInt(entry.lengthOfTime.years, 10) : 0
    const months = entry.lengthOfTime?.months ? parseInt(entry.lengthOfTime.months, 10) : 0

    if (entry.lengthOfTime) {
      durations.push({
        years,
        months
      })
    }
  })

  const startDate = new Date(0)
  let datePlusDurations = startDate

  durations.forEach((d) => {
    datePlusDurations = add(datePlusDurations, d)
  })

  return intervalToDuration({ start: startDate, end: datePlusDurations })
}

export default getHistoryDuration
